import React from 'react';
import { Route, Routes } from 'react-router-dom';
import OnboardingRequestList from './components/OnboardingRequestList';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function OnboardingRequests() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.ONBOARDING) && <Route index element={<OnboardingRequestList />} />}
        </Routes>
    );
}
